var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.audienceInRange)?_c('section',[(_vm.genderAgeChartData.length > 0)?_c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"BrandAnalyticsFansCards","componentProps":{
      icon: 'gender',
      title:
        _vm.socialAccountType === 'YOUTUBE'
          ? 'Subscribers Gender and Age'
          : (_vm.audienceLabel + " Gender and Age"),
      chartBipolarProps: { values: _vm.genderAgeChartData },
      genderAgeProps: { women: _vm.totalWomen, men: _vm.totalMen },
    }}}):_vm._e(),_vm._v(" "),(_vm.countryChartData.length > 0 || _vm.citiesChartData.length > 0)?_c('div',{class:_vm.$style.doubleCards},[(_vm.countryChartData.length > 0)?_c('div',{class:_vm.$style.card},[_c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"BrandAnalyticsFansCards","componentProps":{
          icon: 'country',
          title: (_vm.audienceLabel + " Top Countries"),
          chartHorizontalBarWithStepProps: {
            dataSet: _vm.countryChartData,
            steps: _vm.steps,
            style: 'width:100%',
          },
        }}})],1):_vm._e(),_vm._v(" "),(_vm.citiesChartData.length > 0)?_c('div',{class:_vm.$style.card},[_c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"BrandAnalyticsFansCards","componentProps":{
          icon: 'city',
          title: (_vm.audienceLabel + " Top Cities"),
          chartHorizontalBarWithStepProps: {
            dataSet: _vm.citiesChartData,
            steps: _vm.steps,
            style: 'width:100%',
          },
        }}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(
      _vm.followerCountryChartData.length > 0 ||
      _vm.followerCitiesChartData.length > 0
    )?_c('div',{class:_vm.$style.doubleCards},[(_vm.followerCountryChartData.length > 0)?_c('div',{class:_vm.$style.card},[_c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"BrandAnalyticsFansCards","componentProps":{
          icon: 'country',
          title: 'Followers Top Countries',
          chartHorizontalBarWithStepProps: {
            dataSet: _vm.followerCountryChartData,
            steps: _vm.steps,
            style: 'width:100%',
          },
        }}})],1):_vm._e(),_vm._v(" "),(_vm.followerCitiesChartData.length > 0)?_c('div',{class:_vm.$style.card},[_c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"BrandAnalyticsFansCards","componentProps":{
          icon: 'city',
          title: 'Followers Top Cities',
          chartHorizontalBarWithStepProps: {
            dataSet: _vm.followerCitiesChartData,
            steps: _vm.steps,
            style: 'width:100%',
          },
        }}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.languageChartData.length > 0)?_c('ComponentWithFloatingIconDownload',{attrs:{"component-name":"BrandAnalyticsFansCards","componentProps":{
      icon: 'language',
      title: (_vm.audienceLabel + " Top Languages"),
      chartHorizontalBarWithStepProps: {
        dataSet: _vm.languageChartData,
        inline: true,
        steps: _vm.steps,
        style: 'width:100%',
      },
    }}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }